import { can } from "@repro/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";

/** Admins land on Workspace; everyone else can only see Members. */
export const Route = createFileRoute("/w/$slug/settings/")({
  beforeLoad: ({ context, params }) => {
    const admin = can(context.workspace.role, "settings.manage");
    throw redirect({
      to: admin ? "/w/$slug/settings/workspace" : "/w/$slug/settings/members",
      params,
    });
  },
});
